// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"77ab3fbe","472":"cc570f6e","895":"e049c2cc","940":"acc4a758","968":"6739066a"}[chunkId] + ".css";
};